export enum TaskPriority {
    Normal = 'normal',
    High = 'high',
    Urgent = 'urgent',
}
